@if (isLoading) {
  <app-content-loader></app-content-loader>
}
<div class="step-container columns is-desktop" [class.d-none]="isLoading">
  @if (isPaymentStatusProcessing) {
    <div class="payment-placeholder">
      <div class="payment-placeholder__title">{{ "COMMON.PAYMENT_PLACEHOLDER" | translate }}</div>
    </div>
  }
  <app-aside-bar [statement]="statement" [workFlowController]="workFlowController"></app-aside-bar>
  @if (statement) {
    @if (statement.serviceType !== packageOption.tax_adviser) {
      <div class="thank-you">
        <h1 class="title_42">{{ "THANK_YOU.TITLE" | translate }}</h1>
        @if (!isVeryfying) {
          <p class="subdesc">{{ "THANK_YOU.DESCRIPTION" | translate }}</p>
        } @else {
          @if (isVeryfying) {
            <p class="subdesc">{{ "THANK_YOU.VERIFICATION_PROCESS" | translate }}</p>
          }
        }
        @if (!isIdentityVarificationActive) {
          <div class="thank-you__summary_wrapper">
            <h2 class="title_24">
              {{ "THANK_YOU.TAX_RETURN_TITLE" | translate }}
            </h2>
            <div class="thank-you__summary_container">
              <div class="thank-you__summary form-content">
                <app-card-view-item
                  [statement]="statement"
                  [hideEditing]="true"
                  [hideRemoving]="true"
                  (downloadPdf)="printStatement()"
                  (downloadInvoice)="downloadInvoice()"
                  [hideCloning]="true"
                  (showDownloadDialog)="showDownloadDialog(statement)"
                >
                </app-card-view-item>
              </div>
            </div>
          </div>
          <div class="acceptable-section">
            <mat-checkbox
              [checked]="isResigningFromClaim"
              (change)="checkResigningFromClaim()"
              [attr.data-cy]="'checkboxResigningFromClaim'"
            >
              <span class="title_20">{{ "THANK_YOU.RESIGNATION_FROM_CLAIM" | translate }}</span>
            </mat-checkbox>
            <app-more-info-tooltip
              [alignLeft]="true"
              [isSmall]="true"
              [showText]="false"
              [message]="'TOOLTIP.OWN_CERTIFICATE_TEXT'"
              [titleTooltip]="'TOOLTIP.OWN_CERTIFICATE_TITLE'"
            ></app-more-info-tooltip>
          </div>
          <div class="certification-wrapper">
            <h2 class="title_24"> Sposób weryfikacji tożsamości </h2>
            <div class="certification-container">
              <div class="taxando-certificate-container">
                <app-horizontal-select-button
                  [iconSrc]="'../../../assets/svg/taxando-icon-small.svg'"
                  [title]="'THANK_YOU.SIGN_BY_TAXANDO_CERTIFICATE_TEXT'"
                  [description]="'THANK_YOU.TAXANDO_CERTIFICATE_TEXT'"
                  [isActive]="chosenCertificateType === certificateTypes.TAXANDO_CERTIFICATE"
                  (onClick)="setTaxandoCertificate()"
                ></app-horizontal-select-button>
              </div>
              <div class="taxando-certificate-container">
                <app-horizontal-select-button
                  [iconSrc]="'../../../assets/svg/own-certificate.svg'"
                  [title]="'THANK_YOU.SIGN_BY_MY_CERTIFICATE_TEXT'"
                  [description]="'THANK_YOU.OWN_CERTIFICATE_TEXT'"
                  [isActive]="chosenCertificateType === certificateTypes.OWN_CERTIFICATE"
                  (onClick)="setOwnCertificate()"
                ></app-horizontal-select-button>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (statement.serviceType === packageOption.tax_adviser) {
      <div class="thank-you">
        <h1 class="title_42">{{ "THANK_YOU.TITLE" | translate }}</h1>
        @if (!isVeryfying) {
          <div class="subdesc">{{ "THANK_YOU.TAX_ADVISER_DESCRIPTION" | translate }}</div>
        } @else {
          @if (isVeryfying) {
            <p class="subdesc">{{ "THANK_YOU.VERIFICATION_PROCESS" | translate }}</p>
          }
        }
      </div>
    }
    <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
  }
</div>
